import React from 'react';
import { SiteLink } from 'shared/link/siteLink';

export function AppSideBar() {
  return (
    <div className="appSideBar">
      <div className="appSideBar__scroll">
        <section className="appSideBar__section">
        <h5>ATDW</h5> 
        <ul className="appSideBar__group">
          {/* <li>
            <SiteLink to="/admin/products">Products</SiteLink>
          </li> */}
          <li>
            <SiteLink to="/admin/atdw/search"> Search ATDW</SiteLink>
          </li>
          <li>
            <SiteLink to="/admin/atdw/list"> ATDW List</SiteLink>
          </li>
        </ul>
        <h5>Member</h5> 
        <ul className="appSideBar__group">
          <li>
            <SiteLink to="/admin/member/list"> Member List</SiteLink>
          </li>
        </ul>
        <h5> Filter </h5> 
        <ul className="appSideBar__group">
          <li>
            <SiteLink to="/admin/filter/edit"> Edit Filters </SiteLink>
          </li>
        </ul>
        </section>
      </div>
    </div>
  );
}